import { useRouter } from 'next/router';
import SolarEcommPageLayout from '@/components/SolarEcomm/SolarEcommPageLayout/SolarEcommPageLayout';
import { useRedirectToSolarQuoteInProd } from '@/hooks/solarEcomm/useRedirectToSolarQuoteInProd';

export default function SolarEcommLandingPage() {
  const router = useRouter();
  const isHidden = useRedirectToSolarQuoteInProd();

  if (isHidden) return null;

  return (
    <SolarEcommPageLayout>
      <h1>Solar</h1>
      <button type='button' onClick={() => router.push('/shop/solar/design')}>
        See my offer
      </button>
    </SolarEcommPageLayout>
  );
}
